// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"20a82b28","160":"958176c8","208":"584f6e89","293":"6ffa1ae7","516":"c232bfa6","519":"ff9fe6e2","917":"3082e739","946":"1092a421"}[chunkId] + ".chunk.js";
};